import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { FilterMatchMode } from "primereact/api";
import { Column } from "primereact/column";
import { Button } from "react-bootstrap";
import { Button as PrimeButton } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { ConfirmDialog } from "primereact/confirmdialog";
import { ProgressSpinner } from "primereact/progressspinner";
import axios from "axios";
import { SERVICE_LOCATION, GET_PENDING_WAGES, GET_FITTERS_API, PROCESS_WAGES, DOWNLOAD_WORKCARD_DETAILS_WITH_ALL_IMAGES_BY_MEASUREIDs } from "./../constants/endpoints";
import { SELECT_MEASURES_WITH_SAME_FITTER, WORK_SHARE_100_PERCENT } from "./../constants/errors";

import "./../assets/styles/table.css";
import "./../assets/styles/worksheets.css";

const Pendingwages = (props) => {
    const toast = useRef(null);

    const { data } = props;
    const userDepot = (data !== undefined && data !== null) ? data.data.userDetails.depot : "";
    const userName = (data !== undefined && data !== null) ? data.data.userDetails.userName : "";

    const [loading, setLoading] = useState(false);
    const [pendingWages, setPendingWages] = useState(null);
    const [selectedMeasures, setSelectedMeasures] = useState(null);
    const [disableShowWageProcessButton, setDisableShowWageProcessButton] = useState(true);
    const [showWageProcess, setShowWageProcess] = useState(false);
    const [completionDate, setCompletionDate] = useState(null);
    const [maxDate, setMaxDate] = useState(null);
    const [selectedFitters, setSelectedFitters] = useState(null);
    const [fittersList, setFittersList] = useState(null);
    const [disableRemoveFitterButton, setDisableRemoveFitterButton] = useState(true);
    const [showAddFitter, setShowAddFitter] = useState(false);
    const [selectedAddFitter, setSelectedAddFitter] = useState(null);
    const [selectedRemoveFitter, setSelectedRemoveFitter] = useState(null);
    const [disableAddButtonInAddFitterModal, setDisableAddButtonInAddFitterModal] = useState(true);
    const [showWageProcessConfirmationMessage, setShowWageProcessConfirmationMessage] = useState(false);
    const [wageProcessConfirmationMessage, setWageProcessConfirmationMessage] = useState("");
    const [showPdfViewer, setShowPdfViewer] = useState(false);
    const [pdfUrl, setPdfUrl] = useState("");
    const [dialogHeader, setDialogHeader] = useState("");

    const [filters, setFilters] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState("");

    const [addFitterFilters, setAddFitterFilters] = useState(null)
    const [addFitterGlobalFilterValue, setAddFitterGlobalFilterValue] = useState("");

    useEffect(() => {
        getPendingWages();
        initFilters();
        initAddFitterFilters();
    }, []);

    const getFormattedDate = (dateToFormat) => {
        const year = dateToFormat.getFullYear();
        const month = String(dateToFormat.getMonth() + 1).padStart(2, "0");
        const day = String(dateToFormat.getDate()).padStart(2, "0");
        const formatedDate = `${year}-${month}-${day}`;
        return formatedDate;
    }

    const getPendingWages = async () => {
        setLoading(true);
        const requestData = {
            depot: userDepot
        };
        const endPoint = SERVICE_LOCATION + GET_PENDING_WAGES;
        await axios.post(endPoint, requestData, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        })
            .then((response) => {
                setLoading(false);
                setSelectedMeasures(null);
                if (response.data.isSuccess) {
                    const result = response.data.data.pendingWages;
                    setPendingWages(result);
                }
                else if (!response.data.isSuccess) {
                    setPendingWages(null);
                }
            })
            .catch((error) => {
                setPendingWages(null);
                toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
            })
    }

    const getFitters = async () => {
        const requestData = {
            depot: userDepot
        }
        const endPoint = SERVICE_LOCATION + GET_FITTERS_API;
        await axios.post(endPoint, requestData, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        })
            .then((response) => {
                if (response.data.isSuccess) {
                    let tempFittersList = response.data.data.fitterDetails
                    tempFittersList.sort((a, b) => a.fitterId - b.fitterId)
                    setFittersList(tempFittersList);
                }
                else if (!response.data.isSuccess) {
                    toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 3000 });
                }
            })
            .catch((error) => {
                toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
            })
    }

    const processWages = async () => {
        let selectedMeasureIds = [];
        selectedMeasures.forEach(measures => {
            selectedMeasureIds.push(measures.measureId);
        });
        const workShare = selectedFitters.map(({ fitterId, workShare }) => ({ fitterId, workShare }));
        const requestData = {
            completionDate: getFormattedDate(completionDate),
            processedBy: userName,
            measureIds: selectedMeasureIds,
            workShare: workShare
        }
        const endPoint = SERVICE_LOCATION + PROCESS_WAGES;
        await axios.post(endPoint, requestData, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        })
            .then((response) => {
                if (response.data.isSuccess) {
                    setShowWageProcess(false);
                    setSelectedMeasures(null);
                    setDisableShowWageProcessButton(true);
                    getPendingWages();
                    toast.current.show({ severity: "success", summary: "Success", detail: response.data.data, life: 3000 });
                }
                else if (!response.data.isSuccess) {
                    toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 3000 });
                }
            })
            .catch((error) => {
                toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
            })
    }

    const handleMeasureSelection = (e) => {
        const selectedRecords = e.value;
        const uniquePairs = new Set(selectedRecords.map(item => `${item.fitterId}-${item.fitterName}`));
        const fitterCount = uniquePairs.size;

        if (fitterCount <= 1) {
            setSelectedMeasures(e.value);
            fitterCount === 0 ? setDisableShowWageProcessButton(true) : setDisableShowWageProcessButton(false);
        }
        else {
            toast.current.show({ severity: "error", summary: "Error", detail: SELECT_MEASURES_WITH_SAME_FITTER, life: 3000 });
        }
    }

    const handleShowWageProcess = () => {
        const currentDate = new Date();
        const yesterdaysDate = new Date(currentDate);
        yesterdaysDate.setDate(currentDate.getDate() - 1);
        setCompletionDate(yesterdaysDate);
        setMaxDate(currentDate);

        var fittersObj = [];
        const fitterObj = {
            fitterId: selectedMeasures[0].fitterId,
            fitterName: selectedMeasures[0].fitterName,
            workShare: "100"
        }
        fittersObj.push(fitterObj);
        setSelectedFitters(fittersObj);
        getFitters();
        setShowWageProcess(true);
    }

    const onWageProcessModalClose = () => {
        setShowWageProcess(false);
        setSelectedAddFitter(null);
        setSelectedRemoveFitter(null);
    }

    const handleSaveWages = () => {
        const totalWorkShare = selectedFitters.reduce((total, obj) => total + parseFloat(obj.workShare), 0);
        if (totalWorkShare === 100) {
            const formatedDate = getFormattedDate(completionDate);
            setWageProcessConfirmationMessage(`Process ${selectedMeasures.length} measure(s) for ${formatedDate}`);
            setShowWageProcessConfirmationMessage(true);
        }
        else {
            toast.current.show({ severity: "error", summary: "Error", detail: WORK_SHARE_100_PERCENT, life: 3000 });
        }
    }

    const handleShowAddFiter = () => {
        setDisableAddButtonInAddFitterModal(true);
        setSelectedAddFitter(null);
        clearAddFitterFilter();
        setShowAddFitter(true);
    }

    const handleRemoveFitterSelection = (e) => {
        if (selectedFitters.length > 1) {
            setDisableRemoveFitterButton(false);
            setSelectedRemoveFitter(e.value);
        }
    }

    const handleRemoveFitter = () => {
        let tempSelectedFitters = selectedFitters;
        const remainingFitters = tempSelectedFitters.filter(f => f.fitterId !== selectedRemoveFitter.fitterId);
        const percentageWorkShare = 100 / remainingFitters.length;
        let updatedSelectedFitters = remainingFitters.map(f => { return { ...f, workShare: percentageWorkShare.toFixed(2) } });
        setSelectedFitters(updatedSelectedFitters);
        setSelectedRemoveFitter(null);
        setDisableRemoveFitterButton(true);
    }

    const handleFitterSelectionInAddFitterModal = (e) => {
        setSelectedAddFitter(e.value);
        setDisableAddButtonInAddFitterModal(false);
    }

    const handleAddFitter = () => {
        var tempSelectedFitter = selectedFitters;
        const ifFitterExists = tempSelectedFitter.filter(f => f.fitterId === selectedAddFitter.fitterId);
        if (ifFitterExists.length === 0) {
            const fitterObj = {
                fitterId: selectedAddFitter.fitterId,
                fitterName: selectedAddFitter.fullName,
                workShare: "100"
            }
            tempSelectedFitter.push(fitterObj);
            const percentageWorkShare = 100 / tempSelectedFitter.length;

            let updatedSelectedFitters = tempSelectedFitter.map(f => { return { ...f, workShare: percentageWorkShare.toFixed(2) } });
            setSelectedAddFitter(null);
            setSelectedFitters(updatedSelectedFitters);
        }
        setShowAddFitter(false);
    }

    const accept = () => {
        processWages();
    }

    // edit wageshare
    const workShareEditor = (options) => {
        const handleInputChange = (e) => {
            const value = e.target.value;
            const regex = /^[0-9.]*$/;
            if (regex.test(value) || value === "" || value === ".") {
                options.editorCallback(value);
            }
        };

        return (
            <InputText type="text" className="p-inputtext-sm" value={options.value} onChange={handleInputChange} />
        );
    }
    // edit wageshare ends here

    // pending wages search functionality
    const clearFilter = () => {
        initFilters();
    };

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            worksheetNo: { value: null, matchMode: FilterMatchMode.CONTAINS },
            plotNo: { value: null, matchMode: FilterMatchMode.CONTAINS },
            measure: { value: null, matchMode: FilterMatchMode.CONTAINS },
            location: { value: null, matchMode: FilterMatchMode.CONTAINS },
            wageValue: { value: null, matchMode: FilterMatchMode.CONTAINS },
            quantity: { value: null, matchMode: FilterMatchMode.CONTAINS },
            fitterName: { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
        setGlobalFilterValue("");
    }

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters["global"].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const renderHeader = () => {
        return (
            <div className="row">
                <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                    <PrimeButton id="process-wages" disabled={disableShowWageProcessButton} onClick={handleShowWageProcess}>Process Wages</PrimeButton>
                </div>
                <div className="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8">
                    <div className="flex justify-content-end txt-right">
                        <PrimeButton className="mar-r-10" type="button" icon="pi pi-filter-slash" label="Clear" outlined onClick={clearFilter} tooltip="clear filters" tooltipOptions={{ position: "bottom" }} />
                        <span className="p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
                        </span>
                    </div>
                </div>
            </div>
        );
    };
    const header = renderHeader();
    // pending wages search functionality ends here    


    // add fitters search functionality
    const clearAddFitterFilter = () => {
        initAddFitterFilters();
    }

    const initAddFitterFilters = () => {
        setAddFitterFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            fitterId: { value: null, matchMode: FilterMatchMode.CONTAINS },
            fullName: { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
        setAddFitterGlobalFilterValue("");
    }

    const renderAddFitterHeader = () => {
        return (
            <div className="row">
                <div className={"col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"}>
                    <div className="flex justify-content-end txt-right">
                        <PrimeButton className="mar-r-10" type="button" size="small" icon="pi pi-filter-slash" label="Clear" outlined onClick={clearAddFitterFilter} tooltip="clear filters" tooltipOptions={{ position: "bottom" }} />
                        <span className="p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText value={addFitterGlobalFilterValue} onChange={onGlobalAddFitterFilterChange} className="p-inputtext-sm" placeholder="Keyword Search" />
                        </span>
                    </div>
                </div>
            </div>
        )
    }

    const onGlobalAddFitterFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...addFitterFilters };

        _filters["global"].value = value;

        setAddFitterFilters(_filters);
        setAddFitterGlobalFilterValue(value);
    };

    const addFitterHeader = renderAddFitterHeader();
    // add fitters search functionality ends here  

    const handleHidePDFViewer = () => {
        setShowPdfViewer(false);
    }

    const viewWorkCard = (job) => {
        setLoading(true);
        var selectedDownloadMeasureIds = [];
        const measureIds = {
            measureId: job.measureId
        }
        selectedDownloadMeasureIds.push(measureIds);
        const endPoint = SERVICE_LOCATION + DOWNLOAD_WORKCARD_DETAILS_WITH_ALL_IMAGES_BY_MEASUREIDs;
        axios.post(endPoint, selectedDownloadMeasureIds, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        }).then((response) => {
            setLoading(false);
            if (response.data.isSuccess) {
                if (response.data.data.downloadedWorkCards.length > 0) {
                    (response.data.data.downloadedWorkCards).forEach(workcard => {
                        const base64 = workcard.chunks.join("");
                        const byteCharacters = atob(base64);
                        const byteNumbers = new Array(byteCharacters.length);
                        for (let i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        const byteArray = new Uint8Array(byteNumbers);
                        const blob = new Blob([byteArray], { type: "application/pdf" });
                        const url = URL.createObjectURL(blob);
                        setPdfUrl(url);
                        setDialogHeader(`Worksheet No: ${job.worksheetNo}`);
                        setShowPdfViewer(true);
                    });
                }
            }
            else if (!response.data.isSuccess) {
                setPdfUrl("");
                setShowPdfViewer(false);
                toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 5000 });
            }
        }).catch((error) => {
            setLoading(false);
            toast.current.show({ severity: "error", summary: "Error", detail: error, life: 5000 });
        })
    }

    const handleShowWorkCard = (job) => {
        return <Button id="View" onClick={() => viewWorkCard(job)}>View</Button>
    }

    const renderFittersHeader = () => {
        return (
            <div className="row">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <div className="flex justify-content-end txt-right">
                        <Button className="mar-r-10" disabled={disableRemoveFitterButton} id="remove-fiter" onClick={handleRemoveFitter}>Remove Fitter</Button>
                        <Button className="mar-r-10" id="add-fiter" onClick={handleShowAddFiter}>Add Fitter</Button>
                    </div>
                </div>
            </div>
        );
    }
    const fittersHeader = renderFittersHeader();

    const wageProcessFooterContent = (
        <div className="padt-10">
            <PrimeButton label="Exit" size="small" icon="pi pi-times" onClick={onWageProcessModalClose} className="p-button-text" />
            <PrimeButton label="Process" size="small" icon="pi pi-check" onClick={handleSaveWages} autoFocus />
        </div>
    );

    const addFitterFooterContent = (
        <div className="padt-10">
            <PrimeButton label="Cancel" size="small" icon="pi pi-times" onClick={() => setShowAddFitter(false)} className="p-button-text" />
            <PrimeButton label="Add" size="small" icon="pi pi-check" disabled={disableAddButtonInAddFitterModal} onClick={handleAddFitter} autoFocus />
        </div>
    )

    return (
        <div className={`app ${loading ? "disabled" : ""}`}>
            {
                loading &&
                <div className="spinner-overlay">
                    <ProgressSpinner style={{ width: "50px", height: "50px" }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
                </div>
            }
            <Toast ref={toast} />

            <div className="worksheets-section padl-20">
                <h4>Pending Wages</h4>
            </div>

            <div className="worksheets-section">
                <div className="row">
                    <div className="col-12">
                        <DataTable className="font-12" value={pendingWages} selectionMode="checkbox" selection={selectedMeasures} onSelectionChange={handleMeasureSelection}
                            dataKey="measureId" paginator rows={10} rowsPerPageOptions={[10, 25, 50]} filters={filters} header={header} filterDisplay="row"
                            globalFilterFields={["measureId", "worksheetNo", "plotNo", "measure", "location", "wageValue", "quantity", "depot",
                                "fitterId", "fitterName"]} scrollable tableStyle={{ minWidth: "100rem" }} emptyMessage="No measures availabe with pending wages.">
                            <Column selectionMode="multiple" headerStyle={{ width: "3rem" }}></Column>
                            <Column field="measureId" header="Measure Id" className="table-header" hidden></Column>
                            <Column field="worksheetNo" header="Worksheet No" filter filterPlaceholder="Search by worksheet no" className="table-header"></Column>
                            <Column field="plotNo" header="Plot No" filter filterPlaceholder="Search by plot no" className="table-header"></Column>
                            <Column field="measure" header="Measure" filter filterPlaceholder="Search by measure" className="table-header"></Column>
                            <Column field="location" header="Location" filter filterPlaceholder="Search by location" className="table-header" ></Column>
                            <Column field="wageValue" header="Wage Value(£)" filter filterPlaceholder="Search by wage value" className="table-header"></Column>
                            <Column field="quantity" header="Quantity" filter filterPlaceholder="Search by quantity" className="table-header"></Column>
                            <Column field="depot" header="Depot" className="table-header" hidden></Column>
                            <Column field="fitterId" header="FitterId" className="table-header" hidden></Column>
                            <Column field="fitterName" header="Fitter Name" filter filterPlaceholder="Search by filtter" className="table-header"></Column>
                            <Column header="Workcard" filter filterPlaceholder="View Workcard" body={handleShowWorkCard}></Column>
                        </DataTable>
                    </div>
                </div>
            </div>


            <Dialog header="Process Wages" visible={showWageProcess} style={{ width: "45vw" }} contentStyle={{ height: "23vw" }}
                onHide={onWageProcessModalClose} footer={wageProcessFooterContent}>
                <div>
                    <div className="row">
                        <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 padr-20">
                            <div className="flex flex-column gap-2 fitter-feild">
                                <label htmlFor="fitterNames">Completion Date</label>
                                <Calendar id="completion-date" name="completion-date" value={completionDate}
                                    onChange={e => setCompletionDate(e.value)} maxDate={maxDate} showIcon dateFormat="dd/mm/yy" />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <DataTable className="font-12" value={selectedFitters} header={fittersHeader} scrollable dataKey="fitterId"
                                selectionMode="single" selection={selectedRemoveFitter} onSelectionChange={handleRemoveFitterSelection}
                                tableStyle={{ minWidth: "40rem" }} emptyMessage="No fitters assigned for the selected measures.">
                                <Column field="fitterId" header="Fitter Id" className="table-header"></Column>
                                <Column field="fitterName" header="Fitter Name" className="table-header"></Column>
                                <Column field="workShare" header="% Work" className="table-header" editor={(options) => workShareEditor(options)}></Column>
                            </DataTable>
                        </div>
                    </div>
                </div>
            </Dialog>

            <Dialog header="Select Fitter" visible={showAddFitter} style={{ width: "30vw" }} contentStyle={{ height: "25vw" }}
                onHide={() => setShowAddFitter(false)} footer={addFitterFooterContent}>
                <div>
                    <div className="row col-12">
                        <DataTable className="font-12" value={fittersList} scrollable dataKey="fitterId"
                            filters={addFitterFilters} header={addFitterHeader} globalFilterFields={["fitterId", "fullName"]}
                            selectionMode="single" selection={selectedAddFitter} onSelectionChange={handleFitterSelectionInAddFitterModal}
                            tableStyle={{ minWidth: "20rem" }} emptyMessage="No fitters available.">
                            <Column field="fitterId" header="Fitter Id" className="table-header"></Column>
                            <Column field="fullName" header="Fitter Name" className="table-header"></Column>
                        </DataTable>
                    </div>
                </div>
            </Dialog>

            <Dialog header={dialogHeader} style={{ width: "310vw" }} visible={showPdfViewer} onHide={handleHidePDFViewer}>
                <div>
                    <div className="row">
                        <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                            <PrimeButton id="show-siteattention-measures" label="Back to Accounts" link style={{ fontSize: "12px", paddingLeft: "0px" }} onClick={handleHidePDFViewer} />
                        </div>
                    </div>

                    <div>
                        <iframe title="PDF Viewer" width="100%" height="500px" src={pdfUrl || ""} />
                    </div>
                </div>
            </Dialog>

            <ConfirmDialog visible={showWageProcessConfirmationMessage} message={wageProcessConfirmationMessage} onHide={() => setShowWageProcessConfirmationMessage(false)}
                header="Confirmation" accept={accept} />
        </div>
    )
}

export default Pendingwages;